<template>
  <div id="ir-35-app">
    <StyleContainer />
    <router-view />
  </div>
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400&display=swap");
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,600&display=swap");

#ir-35-app {
  /*==========================
START ======================
==========================*/

  $brand-color: #33b34a;
  $font-stack: Open Sans, sans-serif;
  $font-stack-heading: "Montserrat", sans-serif;
  $black: #000;
  $light-grey: #f8f8f8;
  $border-grey: #e1e1e1;
  $shadow: 0px 7px 16px 4px rgba(0, 0, 0, 0.17);

  .calculator {
    margin-top: 1rem;
    margin-bottom: 1rem;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
  /*@media (min-width: 768px) {
    .calculator {
      width: 690px;
    }
  }*/

  /*==========================
General
==========================*/

  font-size: 14px;
  font-family: $font-stack;
  color: $black;
  font-weight: 300;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 300;
  }
  h2 {
    font-size: 1rem;
    text-align: center;
    position: relative;
    margin-bottom: 2.25rem;
    &:after {
      content: "";
      background: $brand-color;
      width: 3.75rem;
      height: 2px;
      display: block;
      left: 50%;
      left: calc(50% - 1.875rem);
      position: relative;
      top: 0.5rem;
    }
  }
  h4,
  h5 {
    font: 14px $font-stack;
    font-weight: 700;
    &:before {
      content: none;
    }
  }
  h6 {
    font: 12px $font-stack;
    font-weight: 700;
  }
  a {
    color: $brand-color;
  }
  strong {
    font-weight: 700;
  }
  .small {
    font-size: 13px;
  }
  .text-primary {
    color: $brand-color !important;
  }
  .text-secondary {
    color: #b0b0b0 !important;
  }

  .btn {
    border-radius: 0;
    padding: 0.375rem 2rem;
    box-shadow: none !important;
    &[type="submit"] {
      margin-top: 3rem;
    }
  }
  .btn-primary {
    background-color: $brand-color;
    border-color: $brand-color;
    display: block;
    margin: 0 auto;
    &:hover,
    &:active,
    &:focus {
      color: $black !important;
      background-color: #fff !important;
      border-color: $brand-color !important;
    }
  }
  .btn-outline-primary {
    border-color: $brand-color;
    color: $brand-color;
    &:hover,
    &:active,
    &:focus {
      color: #fff !important;
      background-color: $brand-color !important;
      border-color: $brand-color !important;
    }
  }

  .edit-text-link {
    color: $brand-color;
    font-size: 0.75rem;
    cursor: pointer;
  }
  .output-values .edit-text-link {
    margin-top: -2rem;
    margin-bottom: 1.5rem;
  }

  .border-2 {
    border-width: 2px !important;
  }
  .border-primary {
    border-color: $brand-color !important;
  }
  .border-secondary {
    border-color: $border-grey !important;
  }

  .bi-document-spreadsheet {
    cursor: pointer;
    position: absolute;
    right: -0.25rem;
    top: 0.15rem;
    top: calc(50% - 7px);
    color: #b0b0b0;
    &[aria-expanded="true"] {
      color: #000;
    }
  }

  .row {
    position: relative;
  }

  @media (min-width: 768px) {
    h2 {
      font-size: 1.25rem;
    }
  }

  /*==========================
Form
==========================*/
  form {
    margin: 3rem 0;

    .form-control {
      font-size: 14px;
      border-color: $border-grey;
      border-radius: 0.25rem !important;
      text-align: right;
      &:focus {
        border-color: #9a9a9a;
        box-shadow: none;
      }
      &::-webkit-input-placeholder {
        color: #c7c7c7;
      } /* WebKit, Blink, Edge */
      &:-moz-placeholder {
        color: #c7c7c7;
      } /* Mozilla Firefox 4 to 18 */
      &::-moz-placeholder {
        color: #c7c7c7;
      } /* Mozilla Firefox 19+ */
      &:-ms-input-placeholder {
        color: #c7c7c7;
      } /* Internet Explorer 10-11 */
      &::-ms-input-placeholder {
        color: #c7c7c7;
      } /* Microsoft Edge */
      &:disabled,
      &[readonly] {
        background: none;
        border: none;
      }
    }
    .input-group-text {
      background: #fff;
      border: none;
    }
  }
  .form-group {
    margin-bottom: 0.5rem;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
  }
  .input-group {
    position: relative;
  }
  .input-group-prepend {
    position: absolute;
    z-index: 50;
    left: 0;
    top: 0;
    .input-group-text {
      padding-left: 8px;
      padding-right: 8px;
      background: none;
    }
    + input[type="text"] {
      padding-left: 1.5rem;
    }
  }
  .dynamic-expenses .input-group-prepend {
    .input-group-text {
      padding-left: 0.75rem;
    }
  }
  .input-group-append {
    margin-left: 5px;
    right: -3rem;
    .input-group-text {
      padding-left: 0;
      padding-right: 0;
      .b-icon {
        cursor: pointer;
        transition: all 0.3s ease;
        &.bi-plus {
          border: 1px solid #b0b0b0;
          color: #b0b0b0 !important;
        }
        &.bi-plus.disabled {
          border: 1px solid white;
          color: white !important;
        }
        &.bi-trash-fill {
          margin-right: 0.25rem;
          color: #b0b0b0 !important;
        }
        &.bi-plus,
        &.bi-trash-fill {
          cursor: auto;
        }
        &.bi-plus.text-secondary {
          border: 1px solid $brand-color;
          &:hover {
            background: $brand-color;
            color: #fff !important;
          }
        }
        &.bi-trash-fill.text-secondary {
          &:hover {
            color: $black !important;
          }
        }
        &.bi-plus.text-secondary,
        &.bi-trash-fill.text-secondary {
          cursor: pointer;
          color: $brand-color !important;
        }
      }
    }
  }
  @media (min-width: 768px) {
    .input-group-append {
      position: absolute;
    }
  }
  .has-popup small {
    color: #fff !important;
    background: rgba(0, 0, 0, 0.5);
    &:after {
      border: solid transparent;
      border-color: rgba(0, 0, 0, 0);
      border-top-color: rgba(0, 0, 0, 0.5);
    }
  }
  .has-popup .alert {
    border-top-color: rgba(245, 198, 203, 0.5);
    &:after {
      border: solid transparent;
      border-color: rgba(0, 0, 0, 0);
      border-top-color: rgba(245, 198, 203, 0.5);
    }
  }
  .has-popup small,
  .has-popup .alert {
    position: absolute;
    border: none;
    padding: 6px 4px;
    border-radius: 5px;
    bottom: 100%;
    bottom: calc(100% + 5px);
    text-align: center;
    line-height: 1;
    transition: all 0.3s ease;
    font-size: 80%;
    margin: 0;
    width: 100%;
    width: calc(100% - 10px);
    &:after {
      top: 100%;
      left: 50%;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-width: 5px;
      margin-left: -5px;
    }
  }
  /*@media (min-width: 350px) {
    .has-popup small,
    .has-popup .alert {
      top: -55px;
    }
  }
  @media (min-width: 768px) {
    .has-popup small,
    .has-popup .alert {
      top: -45px;
    }
  }*/
  .custom-control-input:checked ~ .custom-control-label::before {
    box-shadow: none;
    color: #fff;
    border-color: $brand-color;
    background-color: $brand-color;
  }
  /*@media (min-width: 768px) {
    form {
      .form-control {
        text-align: right;
      }
    }
  }*/
  /*==========================
Nav Tabs
==========================*/
  .nav-tabs {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    .nav-item {
      position: relative;
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
      &:after {
        background: #fff;
        height: 30px;
        display: block;
        width: 115%;
        content: "";
        position: absolute;
        z-index: 50;
        left: -5%;
      }
      &:nth-child(1) {
        z-index: 10;
        &:after {
          width: 115%;
          left: 0%;
        }
      }
      &:nth-child(2) {
        z-index: 9;
      }
      &:nth-child(3) {
        z-index: 8;
      }
      &:nth-child(4) {
        z-index: 7;
      }
      &:nth-child(5) {
        z-index: 6;
      }
      &:last-child {
        &:after {
          width: 105%;
          right: 0%;
        }
      }
    }

    .nav-item.show .nav-link,
    .nav-link.active {
      background: #fff;
    }
    .nav-link {
      border: none;
      height: 100%;
      background: $light-grey;
      box-shadow: $shadow;
      color: $black;
      font-size: 0.75rem;
    }
  }
  .tabs {
    .tab-content {
      box-shadow: $shadow;
      padding: 2rem 0.75rem;
    }
  }
  @media (min-width: 768px) {
    .tabs {
      .tab-content {
        padding: 3.125rem 4rem;
      }
    }
    .nav-tabs {
      .nav-link {
        font-size: 0.875rem;
      }
    }
  }

  /*==========================
Expand all & Collapse all
==========================*/
  .togglers.row {
    margin-left: 0;
    margin-right: 0;
  }
  @media (min-width: 768px) {
    .togglers.row {
      margin-left: -15px;
      margin-right: -15px;
    }
  }
  .togglers button {
    transition: ease 0.3s all;
    &:hover,
    &:active {
      background: $brand-color;
    }
    &:hover,
    &:focus,
    &.focus,
    &:active,
    &.active {
      border-color: $brand-color;
      box-shadow: none !important;
    }
  }
  .togglers button.focus,
  .togglers button:focus {
  }
  .togglers > * {
    padding: 0.2rem 0.5rem;
    &:first-child {
      border-radius: 5px 0 0 5px;
      margin-right: 2px;
    }
    &:last-child {
      border-radius: 0 5px 5px 0;
    }
  }

  /*==========================
Card
==========================*/
  .card {
    color: #000;
  }
  .input-values {
    margin-bottom: 2rem;
  }
  .wider-box-wrapper .row {
    margin-right: 0;
  }
  .wider-box-wrapper {
    > .card > .card-body {
      padding: 0.75rem;
    }
  }
  .output-values {
    > .row {
      margin-right: 0.25rem;
    }
    .card {
      position: relative;
      margin-bottom: 2rem;
    }
  }
  .summary-box {
    > .card {
      padding-top: 0.75rem;
    }
    .collapse .card > .card-body > .row {
      margin-right: -1rem;
    }
  }
  @media (min-width: 768px) {
    .wider-box-wrapper > * {
      margin-left: -1rem;
      margin-right: -1rem;
    }
    .wider-box-wrapper {
      > .card > .card-body {
        padding: 1.25rem;
      }
    }
  }
  .card {
    border-radius: 10px;
    border-width: 0;
    h4 {
      position: absolute;
      top: -0.75rem;
      background: #fff;
      padding: 0 0.4rem;
      margin-left: -0.4rem;
    }
    h6 {
      padding-top: 0.5rem;
    }
    strong {
      display: block;
      padding: 0.75rem 0;
    }
  }
  .card-body {
    padding: 0.75rem;
    & > *:last-child {
      margin-bottom: 0 !important;
    }
  }
  @media (min-width: 768px) {
    .card-body {
      padding: 1.25rem;
    }
  }

  .collapse .card {
    background-color: rgb(248, 248, 248);
    box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    font-size: 0.8rem;
    &:after,
    &:before {
      bottom: 100%;
      right: 1.5rem;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
    &:after {
      border-color: rgba(248, 248, 248, 0);
      border-bottom-color: #f8f8f8;
      border-width: 9px;
      margin-left: -9px;
    }
    &:before {
      border-color: rgba(237, 237, 237, 0);
      border-bottom-color: #a2a2a2;
      border-width: 9px;
      margin-left: -9px;
      box-shadow: 0px 10px 5px #f8f8f8;
    }
    .collapse .card {
      background-color: #fff;
      box-shadow: none;
      border: 1px solid $border-grey;
      &:after {
        border-color: rgba(248, 248, 248, 0);
        border-bottom-color: #fff;
      }
      &:before {
        border-color: rgba(237, 237, 237, 0);
        border-bottom-color: #a2a2a2;
        box-shadow: 0px 10px 5px #fff;
      }
    }
    & > .card-body > .row {
      margin-left: -1rem;
    }
    & > .card-body > h6 ~ .row {
      margin-left: -0.5rem;
    }
    & > .card-body > div {
      /*margin-left: 1rem;*/
      margin-left: 0;
    }
    @media (min-width: 768px) {
      & > .card-body > h6 ~ .row {
        margin-left: 0;
      }
    }
  }
  .collapse .card-body > .row:last-child > :last-child {
    &:before,
    &:after {
      content: "";
      width: 100%;
      height: 1px;
      display: block;
      right: 0;
      top: 0;
    }
    &:before {
      border-top: 1px solid #9f9f9f;
    }
    &:after {
      border-bottom: double #9f9f9f;
    }
  }

  .fade-enter-active {
    transition: opacity 1s 0.25s;
  }
  .fade-leave-active {
    transition: opacity 1s 0;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  /*==========================
Side Panel
==========================*/
  .sidePanel .card {
    background: #f6f6f6;
    border-radius: 5px;
    font-size: 0.8125rem;
    line-height: 1.2;
    position: relative;
    margin-top: 2rem;
    @media (min-width: 992px) {
      margin-top: 0;
      &:after {
        right: 100%;
        top: 8.5rem;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(246, 246, 246, 0);
        border-right-color: #f6f6f6;
        border-width: 16px;
        margin-top: -16px;
      }
    }
    h4 {
      position: relative;
      background: none;
      font-family: $font-stack-heading;
      font-weight: 600;
      font-size: 0.875rem;
      top: 0;
      padding: 0 0 0.5rem;
      margin: 0 0 1.5rem;
      &:before {
        content: "";
        position: absolute;
        width: 60px;
        height: 2px;
        bottom: 0;
        left: 0;
        border-bottom: 2px solid grey;
        border-bottom: 2px solid $brand-color;
      }
    }
    .card-body {
      padding: 2rem 2.5rem;
      ul {
        text-align: left;
        list-style: none;
        margin-bottom: 0;
        padding-inline-start: 1.25rem;
      }
      ul li {
        list-style: none;
        padding-bottom: 0.75rem;
        position: relative;
      }
      ul li:before {
        content: "";
        background: $brand-color;
        font-weight: 700;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
        font-size: 18px;
        width: 5px;
        height: 5px;
        position: absolute;
        top: 5px;
        border-radius: 50%;
      }
    }
  }


  form, input, .input-group-prepend .input-group-text {
    font-size: 12px !important;
  }
  .input-group-prepend .input-group-text {
    padding-top: 7px;
  }
  .tabs {
    padding-left: .5rem !important;
    padding-right: .5rem !important;
  }
  .dynamic-expenses ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    white-space: pre-line; 
    position:relative;
    top:-3px;
    overflow: visible;
    line-height: 1;
  }
  .dynamic-expenses ::-moz-placeholder { /* Firefox 19+ */
    white-space:pre-line;  
    position:relative;
    top:-3px;
    overflow: visible;
    line-height: 1;
  }
  .dynamic-expenses :-ms-input-placeholder { /* IE 10+ */
    white-space:pre-line;  
    position:relative;
    top:-3px;
    overflow: visible;
    line-height: 1;
  }
  .dynamic-expenses :-moz-placeholder { /* Firefox 18- */
    white-space:pre-line;  
    position:relative;
    top:-3px;
    overflow: visible;
    line-height: 1;
  }
  @media (min-width: 400px) {
    .dynamic-expenses > .input-group:last-child ::-webkit-input-placeholder { 
      white-space: nowrap; 
      position:static;
    }
    .dynamic-expenses > .input-group:last-child ::-moz-input-placeholder { 
      white-space: nowrap; 
      position:static;
    }
    .dynamic-expenses > .input-group:last-child :-ms-input-placeholder { 
      white-space: nowrap; 
      position:static;
    }
    .dynamic-expenses > .input-group:last-child :-moz-input-placeholder { 
      white-space: nowrap; 
      position:static;
    }
  }
  @media (min-width: 500px) {
    .dynamic-expenses > .input-group:first-child ::-webkit-input-placeholder { 
      white-space: nowrap; 
      position:static;
    }
    .dynamic-expenses > .input-group:first-child ::-moz-input-placeholder {
      white-space: nowrap; 
      position:static;
    }
    .dynamic-expenses > .input-group:first-child :-ms-input-placeholder {
      white-space: nowrap; 
      position:static;
    }
    .dynamic-expenses > .input-group:first-child :-moz-input-placeholder {
      white-space: nowrap; 
      position:static;
    }
  }
  @media (min-width: 768px) {
    form, input, .input-group-prepend .input-group-text {
      font-size: 14px !important;
    }
    .input-group-prepend .input-group-text {
      padding-top: .375rem;
    }
    .tabs {
      padding-left: 30px !important;
      padding-right: 30px !important;
    }
  }
}
</style>
<script>
import StyleContainer from "@/components/StyleContainer";
import { setOptions, bootstrap } from "vue-gtag";
export default {
  props: ["googleid"],
  components: {
    StyleContainer
  },
  mounted() {
    // this is where we need to initialise gtag
    // it will default to sanders if nothing is set here
    if (this.googleid) {
      setOptions({
        config: { id: this.googleid }
      });
    }
    bootstrap();
  }
};
</script>
